<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickPasswordChange)" autocomplete="off">
        <div class="vx-row mb-3">
          <div class="vx-col md:w-full w-full md:mb-0">
            <ValidationProvider vid="name" name="old_password" rules="required" v-slot="{ errors }">
              <small class="label">Old Password</small>
              <vs-input type="password" name="old_password" class="w-full"  v-model="old_password" />
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-full w-full md:mb-0">
            <ValidationProvider vid="name" name="password" rules="required|min:8" v-slot="{ errors }">
              <small class="label">New Password</small>
              <vs-input type="password" name="password" class="w-full" v-model="password" />
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-full w-full md:mb-0">
            <ValidationProvider vid="name" name="password_confirmation" rules="required|min:8" v-slot="{ errors }">
              <small class="label">Confirm Password</small>
             <vs-input type="password" name="password_confirmation" class="w-full"  v-model="password_confirmation" />
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <!-- Save & Reset Button -->
        <div class="flex flex-wrap items-center justify-end">
          <vs-button button="submit" class="ml-auto mt-2" >Save Changes</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
        </div>
      </form>
    </ValidationObserver>
  </vx-card>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory';
  const SupplierRepository = RepositoryFactory.get('supplier');
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
export default {
  mixins: [SuccessMessage, ErrorMessages],
  data () {
    return {
      old_password: '',
      password: '',
      password_confirmation: ''
    }
  },
  computed: {
  },
  methods: {
    async onClickPasswordChange() {
      this.$vs.loading();
     try {
       const change = await SupplierRepository.updateStaffPassword({
         'old_password' : this.old_password,
         'password' : this.password,
         'password_confirmation' : this.password_confirmation
       });
       this.showSuccessMessage('Password changed successfully!')
       this.$refs.form.reset()
       this.clearFormData();
     } catch (e) {
       this.convertAndNotifyError(e)
     }
      this.$vs.loading.close()
    },
    clearFormData() {
      this.password = '';
      this.old_password = '';
      this.password_confirmation = '';
    }
  }
}
</script>
